export default __webpack_public_path__ + "static/media/4 (2).d0d700c7.jpg";